export function formatNumber(n: number, digits = 0): string {
  return Number.isFinite(n) ? n.toLocaleString("en-US", { minimumFractionDigits: digits, maximumFractionDigits: digits }) : "-";
}

/** รูปแบบเงิน 12,345 ฿ */
export function formatMoney(n: number): string {
  return `${formatNumber(Math.round(n))} ฿`;
}

const dateOf = (iso: string): Date => new Date(iso.length === 10 ? `${iso}T00:00:00` : iso);
const locale = (lang: "th" | "en") => (lang === "en" ? "en-GB" : "th-TH");

/** วันที่แบบ 13 ต.ค. 2569 (short = ไม่มีปี) ค่าว่างแสดง "-" */
export function formatDate(iso: string | null | undefined, lang: "th" | "en", short = false): string {
  if (!iso) return "-";
  const d = dateOf(iso);
  if (Number.isNaN(d.getTime())) return "-";
  return d.toLocaleDateString(locale(lang), short ? { day: "numeric", month: "short" } : { day: "numeric", month: "short", year: "numeric" });
}

/** วันที่และเวลา เช่น 2 ต.ค. 2569 10:15 */
export function formatDateTime(iso: string, lang: "th" | "en"): string {
  const d = dateOf(iso);
  if (Number.isNaN(d.getTime())) return "-";
  return `${formatDate(iso, lang)} ${d.toLocaleTimeString(locale(lang), { hour: "2-digit", minute: "2-digit", hour12: false })}`;
}

/** วันนี้ตามเวลาเครื่อง รูปแบบ YYYY-MM-DD (ใช้เป็นค่าเริ่มต้นของช่องวันที่) */
export function todayIso(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

/** วันนี้ตามเวลา Asia/Bangkok รูปแบบ YYYY-MM-DD (ค่าเริ่มต้นของวันที่มีผลตอนนำเข้าราคา ไม่ขึ้นกับเขตเวลาของเครื่อง) */
export function todayBangkokIso(now = new Date()): string {
  return new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Bangkok", year: "numeric", month: "2-digit", day: "2-digit" }).format(now);
}

/** จำนวนวันระหว่างวันที่สองวัน (b - a) */
export function daysBetween(a: string, b: string): number {
  return Math.round((dateOf(b).getTime() - dateOf(a).getTime()) / 864e5);
}
